import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../pages/dashboard/Dashboard';
import Opportunities from '../pages/opportunities/Opportunities';
import Quotes from '../pages/quotes/Quotes';
import Bills from '../pages/bills/Bills';
import Settings from '../pages/settings/Settings';
import Products from '../pages/products/Products';
import Accounts from '../pages/accounts/Accounts';

const AppRoutes = () => {
  const isDemo = process.env.REACT_APP_IS_DEMO === 'true';

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/app/dashboard" replace />} />
      <Route path="/app/dashboard" element={<Dashboard />} />
      <Route path="/app/opportunities" element={<Opportunities />} />
      <Route path="/app/quotes" element={<Quotes />} />
      <Route path="/app/bills" element={<Bills />} />
      <Route path="/app/settings" element={isDemo ? <Navigate to="/app/dashboard" replace /> : <Settings />} />
      <Route path="/app/accounts" element={<Accounts />} />
      <Route path="/app/products" element={<Products />} />
      <Route path="*" element={<Navigate to="/appd/ashboard" replace />} />
    </Routes>
  );
};

export default AppRoutes;
